export enum OtpTimeTypes {
  RESEND_ALLOWED_AT = 'resendAllowedAt',
  EXPIRES_AT = 'expiresAt',
}
